import { Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Modal from 'common/modal';

const useStyles = makeStyles(() => ({
  content: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    color: '#1C2541',
  },
  title: {
    fontWeight: 700,
    fontSize: '24px',
    marginTop: '18px',
    marginBottom: '32px',
    alignSelf: 'center',
  },
  doneButton: {
    borderRadius: '100px',
    maxHeight: '40px',
    marginTop: '40px',
    marginBottom: '20px',
    backgroundColor: '#5ED1F0',
    color: '#1C2541',
  },
  // copyContainer: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  // },
  // addressContainer: {
  //   backgroundColor: '#F5F5F5',
  //   padding: '24px 16px',
  //   borderRadius: '8px',
  // },
}));

type Props = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
};

const MailDocumentModal = ({ showModal, setShowModal }: Props) => {
  const classes = useStyles();

  // const onCopyAddress = () => {
  //   const trustateAddress = `
  //       Trustate
  //       802 E Whiting St
  //       Tampa, FL 33602
  //       United States
  //   `;
  //   navigator.clipboard.writeText(trustateAddress);
  //   showMessageBar({
  //     message: 'Address copied to clipboard',
  //     severity: MessageBarSeverity.INFO,
  //   });
  // };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={() => setShowModal(false)}
      showModal={showModal}
      showActions={false}
      content={
        <div className={classes.content}>
          <Typography className={classes.title}>Mail Signed Document</Typography>
          <Typography>Sign and Mail to the Institution directly</Typography>
          {/* <div className={classes.addressContainer}>
            <div className={classes.copyContainer}>
              <Typography>Mail To:</Typography>
              <IconButton onClick={onCopyAddress}>
                <FilterNoneIcon />
              </IconButton>
            </div>
            <div>
              <Typography>Trustate</Typography>
              <Typography>802 E Whiting St</Typography>
              <Typography>Tampa, FL 33602</Typography>
              <Typography>United States</Typography>
            </div>
          </div> */}

          <Button
            variant="outlined"
            className={classes.doneButton}
            onClick={() => setShowModal(false)}
          >
            Done
          </Button>
        </div>
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
};

export default MailDocumentModal;
